import { IPaymentRequest } from "@rentiohq/shared-frontend/dist/types/paymentRequest.types";
import {
  Activities,
  Card,
  DisplayText,
  ESpacings,
} from "@rentiohq/web-shared/dist/components";
import { ts } from "../../../../../../services";
import { getPaymentRequestActivityFilter } from "../../../../../../utils/payment";

interface IProps {
  paymentRequest: IPaymentRequest;
  setTab?: (tab: any) => void;
}

export const PaymentRequestHistory = (props: IProps) => {
  const { paymentRequest } = props;

  return (
    <Card
      space={ESpacings.base}
      heading={
        <DisplayText size="extraSmall" space="tight">
          {ts.system("history")}
        </DisplayText>
      }
    >
      <Activities
        identifier={`payment-request-${paymentRequest.id}`}
        filter={getPaymentRequestActivityFilter(paymentRequest)}
        hasFetchMore={true}
        isCompact={true}
      />
    </Card>
  );
};
